import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { getColor } from 'ui/icons/utils';
import { colors } from 'ui/theme/colors';

export const Fragment16 = ({
  height = 16,
  width = 16,
  color,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M4.9375 3.43628C5.28268 3.43628 5.5625 3.7161 5.5625 4.06128V4.93628C5.5625 5.00258 5.58884 5.06617 5.63572 5.11306C5.68261 5.15994 5.7462 5.18628 5.8125 5.18628H8.4375C8.83532 5.18628 9.21686 5.34431 9.49816 5.62562C9.77946 5.90692 9.9375 6.28845 9.9375 6.68628V7.56128C9.9375 7.90646 9.65768 8.18628 9.3125 8.18628C8.96732 8.18628 8.6875 7.90646 8.6875 7.56128V6.68628C8.6875 6.61997 8.66116 6.55639 8.61428 6.5095C8.56739 6.46262 8.5038 6.43628 8.4375 6.43628H5.8125C5.41467 6.43628 5.03314 6.27824 4.75184 5.99694C4.47054 5.71563 4.3125 5.3341 4.3125 4.93628V4.06128C4.3125 3.7161 4.59232 3.43628 4.9375 3.43628Z"
      fillRule="evenodd"
      clipRule="evenodd"
      /** Use single color if provided, otherwise use multi-color styles or inherit based on getColor() */
      fill={getColor(color ?? colors.iconSubtle, isColorInherited)}
    />
    <path
      d="M11.9375 9.56128C12.2827 9.56128 12.5625 9.8411 12.5625 10.1863V12.8113C12.5625 13.2091 12.4045 13.5906 12.1232 13.8719C11.8419 14.1532 11.4603 14.3113 11.0625 14.3113H9.3125C8.96732 14.3113 8.6875 14.0315 8.6875 13.6863C8.6875 13.3411 8.96732 13.0613 9.3125 13.0613H11.0625C11.1288 13.0613 11.1924 13.0349 11.2393 12.9881C11.2862 12.9412 11.3125 12.8776 11.3125 12.8113V10.1863C11.3125 9.8411 11.5923 9.56128 11.9375 9.56128Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color ?? colors.iconSubtle, isColorInherited)}
    />
    <path
      d="M2.0625 12.5613V13.9363H8.6875V12.5613H2.0625ZM0.8125 12.3738C0.8125 11.787 1.2882 11.3113 1.875 11.3113H8.875C9.4618 11.3113 9.9375 11.787 9.9375 12.3738V14.1238C9.9375 14.7106 9.4618 15.1863 8.875 15.1863H1.875C1.2882 15.1863 0.8125 14.7106 0.8125 14.1238V12.3738Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color ?? colors.iconInteractiveSubtle, isColorInherited)}
    />
    <path
      d="M7.3125 8.18628V9.56128H13.9375V8.18628H7.3125ZM6.0625 7.99878C6.0625 7.41198 6.5382 6.93628 7.125 6.93628H14.125C14.7118 6.93628 15.1875 7.41198 15.1875 7.99878V9.74878C15.1875 10.3356 14.7118 10.8113 14.125 10.8113H7.125C6.5382 10.8113 6.0625 10.3356 6.0625 9.74878V7.99878Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color ?? colors.salmon50, isColorInherited)}
    />
    <path
      d="M2.0625 2.06128V3.43628H8.6875V2.06128H2.0625ZM0.8125 1.87378C0.8125 1.28698 1.2882 0.811279 1.875 0.811279H8.875C9.4618 0.811279 9.9375 1.28698 9.9375 1.87378V3.62378C9.9375 4.21058 9.4618 4.68628 8.875 4.68628H1.875C1.2882 4.68628 0.8125 4.21058 0.8125 3.62378V1.87378Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color ?? colors.iconInfo, isColorInherited)}
    />
  </SvgIcon>
);
